export interface IDonorEvalRecord {

    donorId: number,
    donorEvalBillType: number,
    workupBillType: string,
    donorCenterAlias: string,
    donorAlias: string,
    recipCenterAlias: string,
    recipAlias: string,
    workUpDate: string,
    transplantDate: string,
    invoiceDate: string,
    paidAmount: number,
    paymentDueDate: string,
    achConfirmation: string,
    previousBilling: string,
    paidDateTime: string,
    paymentDueAmount: number,
    donorCenterHasAchOnFile: boolean,
    ccbPayableDays: number,
    hasLate: boolean

}